import { render, staticRenderFns } from "./BallotsStats.vue?vue&type=template&id=6778e442&"
import script from "./BallotsStats.vue?vue&type=script&lang=js&"
export * from "./BallotsStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports